import React, { useState } from 'react'
import LessonIcon from './LessonIcon'
import Settings from '../icons/Settings'
import Modal from './Modal'
import LessonSettingsModal from './LessonSettingsModal'

const LessonSetting = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <LessonIcon onClick={() => setIsOpen(true)} active={false} icon={<Settings />} />
      <Modal isOpen={isOpen} toggleModal={() => setIsOpen(false)}>
        <LessonSettingsModal onClose={() => setIsOpen(false)} />
      </Modal>
    </>
  )
}

export default LessonSetting
